import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const completePlanReversalRoutesDictionary =
  moduleRouteDictionaryFactory(
    'completePlanReversal',
    'complete-plan-reversal',
    {
      detail: ':assignmentId/:reversalId',
    },
  );
